import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, watch } from "vue";
import Loader from "./loader/loader.vue";
import moment from "moment";
import { Dogspaces, Kennels } from "@busy-human/k9-library";
import { useKennelCount } from "@/store/kennelCounts";
import { events } from "@/events";

type Props = {
	dogType: Dogspaces.Sizes
	fromDate?: Date
}

export default /*@__PURE__*/_defineComponent({
  __name: 'bulk-edit',
  props: {
    dogType: {},
    fromDate: {}
  },
  emits: ["close"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;
const emit = __emit;

const kennelStore = useKennelCount();

const loading = ref(false);
const useLegacyAction = ref(false);
const toggleSwitch = () => (useLegacyAction.value = !useLegacyAction.value);

const bulkAction = ref<'Add' | 'Remove' | 'Set Total'>('Add');

const selectedDogSize = ref<Dogspaces.Sizes | 'all'>(props.dogType);

watch(() => props.dogType, size => { selectedDogSize.value = size; });

// const dogLabel = computed(() => {
// 	if (!removeDog.value) {
// 		return "Add a Dog";
// 	}
// 	return "Remove a Dog";
// });

const startDate = ref("");
const endDate = ref("");

async function handleBook() {
	if(useLegacyAction.value){
		await handleBookAction();
	}else{
		await handleBookList();
	}
}

const buttonDisabled = computed(() => {
	if(useLegacyAction.value){
		return !slotIsAvailable.value || !kennelStore.defaultKennelMax;
	}else{
		return invalidSizes.value.length > 0;
	}
});

//Bulk List Functions
const givenCounts = ref(Kennels.Collection.defaults().kennelCount);
const givenMax = ref(Kennels.Collection.defaults().kennelCount);

async function handleBookList(){
	loading.value = true;
	await kennelStore.adjustKennelCountsBulk(startDate.value, endDate.value, givenCounts.value, givenMax.value);
	loading.value = false;
}

const invalidSizes = computed(() => {
	const invalid: string[] = [];
	const sizes = Object.values(Dogspaces.Sizes);
	for(const size of sizes){
		if(givenMax.value[size] - givenCounts.value[size] < 0){
			invalid.push(size);
		}
	}

	return invalid;
});

const isAvailableTextList = computed(() => {
	if(invalidSizes.value.length > 0){
		return `Space Unavailable for ${invalidSizes.value[0]}`;
	}else{
		return "Space Available";
	}
});

//Bulk Action Functions
const dogAmount = ref(1);

async function handleBookAction(){
	console.log(startDate.value, endDate.value);
	loading.value = true;
	if(bulkAction.value === 'Set Total'){
		await kennelStore.setMax(startDate.value, endDate.value, selectedDogSize.value, dogAmount.value);
	}else{
		await kennelStore.addKennel(startDate.value, endDate.value, selectedDogSize.value, bulkAction.value === 'Remove' ? -dogAmount.value : dogAmount.value);
	}
	events.emit("kennel:reload");
	loading.value = false;
	
	emit('close');
}

const slotIsAvailable = ref(false);
const firstUnavailable = ref("");
const sizeUnavailable = ref<Dogspaces.Sizes | null>(null);
watch(() => [startDate.value, endDate.value, selectedDogSize.value, bulkAction.value, dogAmount.value], async () => {
	if(bulkAction.value !== 'Add') {
		slotIsAvailable.value = true;
		return;
	}

	const sizes = selectedDogSize.value === 'all' ? Object.values(Dogspaces.Sizes) : [selectedDogSize.value];
	for(const size of sizes){
		const check = await kennelStore.kennelSpaceAvailable(startDate.value, endDate.value, size, dogAmount.value);

		if(check.avail) {
			slotIsAvailable.value = true;
			firstUnavailable.value = "";
			sizeUnavailable.value = null;
		} else {
			const firstUnavail = check.results.find(r => !r.avail);
			if(!firstUnavail) throw new Error("What?");
			slotIsAvailable.value = false;
			firstUnavailable.value = moment(firstUnavail.date).format('MM/DD/YY');
			sizeUnavailable.value = size;
			break;
		}
	}
});

const isAvailableText = computed(() => {
	if (slotIsAvailable.value) {
		return "Space Available";
	}
	
	//Swap Endate for a date that is full
	return `${firstUnavailable.value} does not have space available for ${sizeUnavailable.value} kennels`;
});



const daysBetween = computed(() => `${moment(endDate.value).diff(moment(startDate.value), 'days', false)} Day(s) Total`);

onMounted(() => {
	const now = moment(props.fromDate);
	startDate.value = now.format("YYYY-MM-DD");
	endDate.value = now.add(1, 'd').format("YYYY-MM-DD");
});


const __returned__ = { props, emit, kennelStore, loading, useLegacyAction, toggleSwitch, bulkAction, selectedDogSize, startDate, endDate, handleBook, buttonDisabled, givenCounts, givenMax, handleBookList, invalidSizes, isAvailableTextList, dogAmount, handleBookAction, slotIsAvailable, firstUnavailable, sizeUnavailable, isAvailableText, daysBetween, ref, computed, onMounted, watch, Loader, get moment() { return moment }, get Dogspaces() { return Dogspaces }, get Kennels() { return Kennels }, get useKennelCount() { return useKennelCount }, get events() { return events } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})